import { render } from "./SurveyOrder.vue?vue&type=template&id=8c2eee4a"
import script from "./SurveyOrder.vue?vue&type=script&lang=js"
export * from "./SurveyOrder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__